import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import queryString from 'query-string';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Pager from 'admin/components/shared/Pager';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import { toQueryParams, formatUUID, formatNum, formatDate } from 'admin/utils';
import { getKioskPlays } from 'admin/actions/devices';
import styles from './styles.scss';

class KioskPlays extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 20 };
    this.params = queryString.parse(this.props.location.search);
  }

  componentDidMount() {
    this.fetchKioskPlays();
  }

  onChangePage = (page) => {
    this.fetchKioskPlays({ page });
  }

  fetchKioskPlays(pagination) {
    const pageParams = Object.assign({}, this.defaultPagination, pagination);
    const params = Object.assign({}, pageParams, { kiosk_id: this.params.kiosk_id });
    this.props.getKioskPlays(toQueryParams(params, true));
  }

  formatKioskPlayStatus(KioskPlayStatus) {
    switch (KioskPlayStatus) {
      case 'ongoing':
        return 'スタート';
      case 'done':
        return '完了';
      case 'printed':
        return '印刷';
      case 'canceled':
        return 'キャンセル';
      case 'aborted':
        return '異常終了';
      case 'timeout':
        return 'タイムアウト';
      default:
        return KioskPlayStatus;
    }
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: 'チャージ履歴', href: '/', active: true },
    ];
    const columns = [
      { label: 'ID', align: 'center', size: 2 },
      { label: '取引状態', align: 'center', size: 2 },
      { label: '金額', align: 'center', size: 2 },
      { label: '作成日時', align: 'center', size: 2 },
      { label: '更新日時', align: 'center', size: 2 },
    ];
    const rows = this.props.kioskPlays.rows.map(kioskPlay => [
      {
        data:
        (
          <Link to={`/settings/devices/kiosks/plays/${kioskPlay.kiosk_play_id}?terminal_name=${this.params.kiosk_name}`}>
            {formatUUID(kioskPlay.kiosk_play_id)}
          </Link>
        ),
        align: 'center',
      },
      { data: (<span>{this.formatKioskPlayStatus(kioskPlay.status)}</span>), align: 'center' },
      { data: (<span>¥ {formatNum(kioskPlay.total_amount)}</span>), align: 'center' },
      { data: (<span>{formatDate(kioskPlay.created_at)}</span>), align: 'center' },
      { data: (<span>{formatDate(kioskPlay.updated_at)}</span>), align: 'center' },
    ]);
    return (
      <div>
        <Breadcrumb items={crumb} />
        <div styleName="headline">端末ID：{this.params.kiosk_id}　端末名：{this.params.kiosk_name}</div>
        <div styleName="list-table">
          <TableHeader columns={columns} />
          <TableRows rows={rows} columns={columns} />
        </div>
        <Pager
          pagination={this.props.kioskPlays.pagination}
          onChangePage={this.onChangePage}
        />
      </div>
    );
  }
}

KioskPlays.defaultProps = {
  kioskPlays: { rows: [], pagination: {} },
  getKioskPlays: PropTypes.func,
};

KioskPlays.propTypes = {
  getKioskPlays: PropTypes.func,
  kioskPlays: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
      kiosk_play_id: PropTypes.number,
      cashtray_uuid: PropTypes.string,
      status: PropTypes.string,
      total_amount: PropTypes.number,
    })),
    pagination: PropTypes.shape({
      has_next: PropTypes.bool,
      has_prev: PropTypes.bool,
      max_page: PropTypes.number,
      per_page: PropTypes.number,
      current: PropTypes.number,
    }),
  }),
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  kioskPlays: state.device.kioskPlays,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getKioskPlays,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(KioskPlays, styles));
